import { Mediator, app } from "modular-openscriptjs";
import {
    eParse,
    inform,
    approved,
    store,
    getStore,
    deleteFromStorage,
    acknowledge,
} from "../helpers";
import { STRINGS, api, uc, gc, dc } from "../declarations";
import { routes } from "../backendRoutes";

const $e = app("$e");

export class Cart extends Mediator {
    $$order = {
        placed_repeated: (ed, event) => {
            this.getCart();
        },
    };

    $$cart = {
        itemSelected: (ed, event) =>
            this.broadcast($e.cart.needs.itemAddition, ed),

        needs: {
            itemAddition: (ed, event) => {
                this.addToCart(ed, event);
            },

            itemUpdate: (ed, event) => {
                this.updateItem(ed, event);
            },

            itemRemoval: (ed, event) => {
                this.removeFromCart(ed, event);
            },

            allItems: (ed, event) => {
                this.getCart();
            },
        },
    };
    $$user = {
        authenticated: async (ed, event) => {
            this.getCart();
        },

        loggedOut: async (ed, event) => {
            uc.cart.value = {};
            await deleteFromStorage("carata-cart");
            this.setCart({});
        },
    };

    $$app = {
        loaded: () => {
            this.getCart();
        },
    };

    async addToCart(ed, event) {
        let data = eParse(ed);
        let product = data.message.item;
        let qty = parseInt(data.message.get("quantity", 1));

        let cartItem = data.message.cartItem || {
            product: product,
            finalBasePrice:
                product.price ||
                product.selling_price ||
                product.final_price ||
                0,
            selectedFeatures: {},
            extraQuantities: {},
            selectedExtraFeatures: {},
            extras: {},
            quantity: qty,
        };

        if (gc.user.value?.id) {
            api.post(routes.cartItems, {
                buyable_id: product.id,
                buyable_type:
                    product.buyable_type ||
                    (product.selling_price
                        ? "App\\Models\\Product"
                        : "App\\Models\\OrderProduct"),
                quantity: qty,
                selected_options: {
                    finalBasePrice: cartItem.finalBasePrice,
                    selectedFeatures: cartItem.selectedFeatures,
                    extraQuantities: cartItem.extraQuantities,
                    selectedExtraFeatures: cartItem.selectedExtraFeatures,
                    extras: cartItem.extras || {},
                },
            }).then((res) => {
                this.setCartFromResponse(res);
                inform("Item added to cart", STRINGS.SUCCESS);
            });
        } else {
            let cart = await this.getStoredCart();
            // Generate unique hash based on selections for row key grouping
            let payloadStr = JSON.stringify([
                cartItem.selectedFeatures,
                cartItem.extraQuantities,
                cartItem.selectedExtraFeatures,
            ]);
            let hash = 0;
            for (let i = 0; i < payloadStr.length; i++) {
                hash = (hash << 5) - hash + payloadStr.charCodeAt(i);
                hash |= 0;
            }
            let itemHash = Math.abs(hash).toString(16);
            let rowId = `row-${product.id}-${itemHash}`;

            if (cart[rowId]) {
                cart[rowId].qty = parseInt(cart[rowId].qty) + qty;
            } else {
                cart[rowId] = {
                    id: product.id,
                    name: product.name,
                    qty: qty,
                    price: cartItem.finalBasePrice,
                    buyable_type:
                        product.buyable_type ||
                        (product.selling_price
                            ? "App\\Models\\Product"
                            : "App\\Models\\OrderProduct"),
                    options: {
                        description: product.description,
                        product: product,
                        finalBasePrice: cartItem.finalBasePrice,
                        selectedFeatures: cartItem.selectedFeatures,
                        extraQuantities: cartItem.extraQuantities,
                        selectedExtraFeatures: cartItem.selectedExtraFeatures,
                        extras: cartItem.extras || {},
                    },
                    model: product,
                };
            }

            await this.saveCart(cart);
            inform("Item added to cart", STRINGS.SUCCESS);
        }

        this.send($e.cart.itemAdded, ed);
    }

    async updateItem(ed, event) {

        let data = eParse(ed);

        let qty = parseInt(data.message.get("quantity", 1));
        let rowId = data.message.rowId;
        let cartItemData = data.message.cartItem || null;

        if (gc.user.value?.id) {
            let cartItem = rowId ? uc.cart.value[rowId] : null;
            if (cartItem && cartItem.cart_item_id) {
                if (cartItemData) {
                    let optionsPayload = {
                        finalBasePrice: cartItemData.finalBasePrice,
                        selectedFeatures: cartItemData.selectedFeatures,
                        extraQuantities: cartItemData.extraQuantities,
                        selectedExtraFeatures: cartItemData.selectedExtraFeatures,
                        extras: cartItemData.extras || {},
                    };

                    api.put(`${routes.cartItems}/${cartItem.cart_item_id}`, {
                        quantity: qty,
                        selected_options: optionsPayload,
                    }).then((res) => {
                        this.setCartFromResponse(res);
                    });
                } else {
                    api.put(`${routes.cartItems}/${cartItem.cart_item_id}/quantity`, {
                        quantity: qty,
                    }).then((res) => {
                        this.setCartFromResponse(res);
                    });
                }
            }
        } else {
            let cart = await this.getStoredCart();
            if (rowId && cart[rowId]) {
                cart[rowId].qty = qty;
                if (cartItemData) {
                    cart[rowId].price = cartItemData.finalBasePrice;
                    cart[rowId].options = {
                        description: cart[rowId].options?.description,
                        product: cart[rowId].options?.product,
                        finalBasePrice: cartItemData.finalBasePrice,
                        selectedFeatures: cartItemData.selectedFeatures,
                        extraQuantities: cartItemData.extraQuantities,
                        selectedExtraFeatures:
                            cartItemData.selectedExtraFeatures,
                    };
                }
                await this.saveCart(cart);
                this.send($e.cart.itemAdded, ed);
            }
        }
    }

    async removeFromCart(ed, event) {
        if (!approved(event, ed, "You want to remove this item from your cart"))
            return;

        let { message } = eParse(ed);
        let rowId = message.rowId;

        if (gc.user.value?.id) {
            let cartItem = rowId ? uc.cart.value[rowId] : null;
            if (cartItem && cartItem.cart_item_id) {
                api.delete(`${routes.cartItems}/${cartItem.cart_item_id}`).then(
                    (res) => {
                        this.setCartFromResponse(res);
                        acknowledge({
                            title: "Item Removed",
                            message:
                                "We have successfully removed the item from your Cart",
                            close_text: "That's Good",
                        });
                    },
                );
            }
        } else {
            let cart = await this.getStoredCart();
            if (rowId) {
                delete cart[rowId];
            }

            await this.saveCart(cart);

            acknowledge({
                title: "Item Removed",
                message: "We have successfully refused the item from your Cart",
                close_text: "That's Good",
            });
        }
        this.broadcast($e.cart.itemAdded, ed);
    }

    getCart() {
        if (gc.user.value?.id) {
            api.get(routes.cartItems).then((res) => {
                this.setCartFromResponse(res);
            });
        } else {
            this.getStoredCart().then((cart) => {
                this.setCart(cart);
            });
        }
        return this;
    }

    setCartFromResponse(res) {
        if (!res.data?.cart) return;

        let cart = {};
        res.data.cart.forEach((item) => {
            let buyable = item.buyable;
            if (!buyable) return;

            let opts = item.content?.selected_options || {};
            let rowId = `row-${buyable.id}-${item.id}`;

            cart[rowId] = {
                id: buyable.id,
                cart_item_id: item.id,
                name: item.content?.name || buyable.name,
                qty: item.quantity,
                price:
                    item.price ||
                    item.content?.price ||
                    opts.finalBasePrice ||
                    buyable.price ||
                    buyable.selling_price,
                discounted_price: item.content?.discounted_price || null,
                thumbnail: item.content?.thumbnail || null,
                buyable_type: item.buyable_type,
                options: {
                    description: buyable.description,
                    product: buyable,
                    finalBasePrice:
                        item.price ||
                        opts.finalBasePrice ||
                        item.content?.price ||
                        buyable.price ||
                        buyable.selling_price,
                    selectedFeatures: opts.selectedFeatures || {},
                    extraQuantities: opts.extraQuantities || {},
                    selectedExtraFeatures: opts.selectedExtraFeatures || {},
                    extras: opts.extras || {},
                },
                model: buyable,
            };
        });

        this.saveCart(cart);
    }

    async getStoredCart() {
        try {
            return (await getStore("carata-cart")) || {};
        } catch (e) {
            return {};
        }
    }

    async saveCart(cart) {
        await store("carata-cart", cart);
        this.setCart(cart);
    }

    setCart(cart = {}) {
        let map = {};

        for (let rowId in cart) {
            let item = cart[rowId];
            if (!map[item.id]) {
                map[item.id] = [];
            }
            map[item.id].push({ rowId, item: item });
        }

        uc.cartMap.value = map;
        uc.cart.value = cart;
        dc.cartLoaded.value = true;
    }
}
